import * as moment from 'moment';
import * as DateTimeModule from 'react-datetime';
import { useRef, useState } from 'react';

const DateTime = (DateTimeModule as any).default;

interface IMyDTPickerProps extends DateTimeModule.DatetimepickerProps {
    useCloseButton: boolean,
    dateFormat: string,
    timeFormat: string | boolean,
    placeholder?: string
}

const MyDTPicker = (props: IMyDTPickerProps) => {
    const [open, setOpen] = useState(false);
    const dateRef = useRef(null);

    const handleChange = (value: any) => {
        let currentValue = props.initialValue ? props.initialValue : props.value;
        let fullFormat = typeof props.timeFormat === 'string'
            ? `${props.dateFormat} ${props.timeFormat}`
            : props.dateFormat;
        let selDate = moment.isMoment(value) ? value : moment(value, fullFormat);
        let currDate = moment(currentValue, fullFormat);

        if (selDate.isSame(currDate, 'day')) {
            props.onChange(value);
        } else {
            let currTime = currDate.format("HH:mm");
            let fullDate = selDate.format(props.dateFormat) + ' ' + currTime;

            props.onChange(fullDate);
        }
    };

    const handleClose = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setOpen(false);

        props.onClose('');
    };

    const handleBlur = () => {
        props.onClose('');
    };

    const renderView = (mode, renderDefault) => {
        // Only for years, months and days view
        if (mode === 'time') return renderDefault();

        return (
            <div className='wrapper'>
                {renderDefault()}
                <div className='text-center'>
                    <button style={{ color: '#fff', backgroundColor: '#337ab7', borderColor: '#2e6da4', borderRadius: 3 }} onClick={(e) => handleClose(e)}>Close</button>
                </div>
            </div>
        );
    };

    let value = props.initialValue ? props.initialValue : props.value;

    if (props.useCloseButton)
        return (
            <DateTime
                ref={dateRef}
                dateFormat={props.dateFormat}
                timeFormat={props.timeFormat}
                open={open}
                inputProps={{ ...props.inputProps, placeholder: props.placeholder, onFocus: () => setOpen(true) }}
                value={value}
                // initialViewMode='days'
                renderView={(mode, renderDefault) =>
                    renderView(mode, renderDefault)
                }
                isValidDate={props.isValidDate}
                onChange={handleChange}
            />
        );

    return (
        <DateTime
            dateFormat={props.dateFormat}
            timeFormat={props.timeFormat}
            inputProps={{ ...props.inputProps }}
            closeOnClickOutside={props.closeOnClickOutside}
            value={value}
            onChange={handleChange}
            onClose={handleBlur}
            isValidDate={props.isValidDate}
        />
    );
}

export default MyDTPicker;